export const getStatusBadgeColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'drafting':
    case 'in field':
    case 'partially received':
    case 'in transit':
    case 'in progress':
    case 'awaiting products':
    case 'recruiting':
    case 'processing':
    case 'shipping':
      return 'yellow';

    // Finished work steps back to neutral instead of competing with the statuses still in motion;
    // the check `isDoneStatus` draws carries "done" (EPD-1470). Spelled out rather than left to
    // `default` so the choice is visible next to the greens it used to share.
    case 'completed':
      return 'gray';

    case 'approved':
    case 'received':
    // A project that has left the customer's hands and is with Highlight.
    case 'submitted':
    case 'in review':
      return 'green';

    // Fielding is done and the results are being prepared.
    case 'results pending':
      return 'blue';

    case 'needs review':
    // A recruit that has stopped sending opt-ins before its target.
    case 'paused':
    case 'out of highlighters':
      return 'orange';

    case 'rejected':
    case 'disqualified':
    case 'excluded':
      return 'red';

    default:
      return 'gray';
  }
};

/** Whether the status means the work is finished — drawn with a check rather than a status dot. */
export const isDoneStatus = (status: string): boolean => status.toLowerCase() === 'completed';

// (CP-9972) TODO: Workaround to display desired statuses on the frontend without fully updating the types across the backend
// Eventually we should probably shift to the ProjectAPI types for this everywhere and add these as real statuses.
export const getStatusBadgeLabel = (status: string): string => {
  const STATUS_LABELS: Record<string, string> = {
    'results pending': 'Fielding Complete',
  };
  return STATUS_LABELS[status.toLowerCase()] ?? status;
};
